export const LangText: any = {
    us: {
        ViewAll: 'View All',
        ViewLess: 'View Less',
        ALL: 'All',
        BlogCenter: 'Blog Center',
    },
    jp: {
        ViewAll: 'すべて表示',
        ViewLess: '少なく表示',
        ALL: 'すべて',
        BlogCenter: 'ブログセンター',
    },
    kr: {
        ViewAll: '모두 보기',
        ViewLess: '간략히 보기',
        ALL: 'All',
        BlogCenter: '블로그 센터',
    },
    de: {
        ViewAll: 'Alles anzeigen',
        ViewLess: 'Weniger anzeigen',
        ALL: 'Alle',
        BlogCenter: 'Blog-Zentrum',
    },
    es: {
        ViewAll: 'Ver todo',
        ViewLess: 'Ver menos',
        ALL: 'Todos',
        BlogCenter: 'Centro de Blog',
    },
    fr: {
        ViewAll: 'Voir tout',
        ViewLess: 'Afficher moins',
        ALL: 'Tous',
        BlogCenter: 'Centre de Blog',
    },
    it: {
        ViewAll: 'Visualizza tutto',
        ViewLess: 'Mostra meno',
        ALL: 'Tutti',
        BlogCenter: 'Centro Blog',
    },
};
